import config from "../config.json";
import http from "../Services/httpService";

function login(data) {
    //http.setJwt(http.getLocalJwt());
    return http.post(`${config.apiUrl}/api/kanon/Account/Login`, data);
}

function RequestVerifyCode(mobile, codeMeli) {
    //http.setJwt(http.getLocalJwt());
    //return http.get(`/WeatherForecast/get1`);
    return http.post(`${config.apiUrl}/api/kanon/Account/RequestVerifyCode?mobile=${mobile}&codeMeli=${codeMeli}`);
}



function SettingGet() {
    http.setJwt(http.getLocalJwt());
    return http.get(`${config.apiUrl}/api/kanon/Ozvesetting/Get`);
}

function OzveGet() {
    http.setJwt(http.getLocalJwt());
    return http.post(`${config.apiUrl}/api/kanon/WebOzve/Get`);
}

function RequestLoan() {
    http.setJwt(http.getLocalJwt());
    return http.post(`${config.apiUrl}/api/kanon/WebOzve/RequestLoan`);
}

function RequestTravel() {
    http.setJwt(http.getLocalJwt());
    return http.post(`${config.apiUrl}/api/kanon/WebOzve/RequestTravel`);
}

function Payment(mode) {
    http.setJwt(http.getLocalJwt());
    return http.post(`${config.apiUrl}/api/kanon/Payment/Payment?mode=${mode}`);
}
function Verify(idGet,transId,factorId) {
    http.setJwt(http.getLocalJwt());
    return http.post(`${config.apiUrl}/api/kanon/Payment/Verify?factorId=${factorId}&trans_id=${transId}&id_get=${idGet}`);
}

function CreateData(data) {
    let form = new FormData();
    if ('shaba' in data)
        form.append('Shaba', data.shaba);
    if ('shobeh' in data)
        form.append('Shobeh', data.shobeh);
    form.append('Form1', data.form1);
    form.append('Form2', data.form2);

    for (let i = 0; i < data.detail.length; i++) {
        form.append(`detail[${i}].name`, data.detail[i].name);
        form.append(`detail[${i}].family`, data.detail[i].family);
        form.append(`detail[${i}].fatherName`, data.detail[i].fatherName);
        form.append(`detail[${i}].code`, data.detail[i].code);
        form.append(`detail[${i}].codeMeli`, data.detail[i].codeMeli);
        form.append(`detail[${i}].placeBirthName`, data.detail[i].placeBirthName);
        form.append(`detail[${i}].birthDay`, data.detail[i].birthDay);
        form.append(`detail[${i}].nesbat`, data.detail[i].nesbat);
    }
    return form;
}

function RequestInsurance(data) {
    const form = CreateData(data);
    http.setJwt(http.getLocalJwt());
    return http.post(`${config.apiUrl}/api/kanon/WebOzve/RequestInsurance`, form);
}

function ReportInsurance(data) {
    const form = CreateData(data);
    http.setJwt(http.getLocalJwt());
    return http.post(`${config.apiUrl}/api/kanon/OzveInsurancePrint/preview`, form);
}



function OzveRegister(data) {
    //http.setJwt(http.getLocalJwt());
    let form = new FormData();
    form.append('name', data.name);
    form.append('family', data.family);
    form.append('nameFather', data.nameFather);
    form.append('code', data.code);
    form.append('codeMeli', data.codeMeli);
    form.append('birthDay', data.birthDay);
    form.append('mostamariCode', data.mostamariCode);
    form.append('telfix', data.telfix);
    form.append('mobile', data.mobile);
    form.append('address', data.address);
    form.append('seriall', data.seriall);
    form.append('personeliPic', data.personeliPic);
    form.append('cardMeliPic', data.cardMeliPic);
    form.append('codePic', data.codePic);
    form.append('movafeghPic', data.movafeghPic);
    if ('mostameriShobeh' in data)
        form.append('mostameriShobeh', data.mostameriShobeh);
    form.append('shobeh', data.shobeh);
    //http.setJwt(http.getLocalJwt()); 
    return http.post(`${config.apiUrl}/api/kanon/WebOzve/post`, form);
}


//-----
function ShobehListPublic(data) {
    //http.setJwt(http.getLocalJwt());
    return http.post(`${config.apiUrl}/api/kanon/shobeh/ListPublic`, data)
}


//----
function InsuranceList() {
    http.setJwt(http.getLocalJwt());
    return http.post(`${config.apiUrl}/api/kanon/OzveInsurance/List`)
}
function InsuranceGetDetail(id) {
    http.setJwt(http.getLocalJwt());
    return http.post(`${config.apiUrl}/api/kanon/OzveInsurance/GetDetail?id=${id}`)
}
function RequestInsuranceCancel() {
    http.setJwt(http.getLocalJwt());
    return http.post(`${config.apiUrl}/api/kanon/WebOzve/RequestInsuranceCancel`);
}
function RequestInsuranceGold() {
    http.setJwt(http.getLocalJwt());
    return http.post(`${config.apiUrl}/api/kanon/WebOzve/RequestInsuranceGold`);
}

function RequestInsuranceGoldCancel() {
    http.setJwt(http.getLocalJwt());
    return http.post(`${config.apiUrl}/api/kanon/WebOzve/RequestInsuranceGoldCancel`);
}

export default {
    login, RequestVerifyCode
    , OzveGet, OzveRegister
    , SettingGet
    , RequestLoan
    , RequestTravel
    , RequestInsurance
    , Payment, Verify


    , ShobehListPublic

    , InsuranceList, InsuranceGetDetail, ReportInsurance, RequestInsuranceCancel,RequestInsuranceGold,RequestInsuranceGoldCancel

};
